import { MultipleLookupBaseControl } from "./multiple-lookup-base-control";
import { LookupValue } from "../../../../../models/lookups/lookup.models";
import { type MultipleLookupValues, type MultipleLookupExclusiveAnswers } from "../multiple-lookups-control";
import { bindable, autoinject, BindingEngine, Disposable } from "aurelia-framework";

@autoinject
export class MultipleLookupWithAdd extends MultipleLookupBaseControl {

	@bindable
	protected itemSource: LookupValue[];

	@bindable
	protected values: MultipleLookupValues;

	@bindable
	protected exclusiveAnswers: MultipleLookupExclusiveAnswers;

	@bindable
	protected readonly: boolean = false;

	public selectedValues: number[] = [];
	public subscriptions: Disposable[] = [];

	public constructor(element: Element, private bindingEngine: BindingEngine) {
		super(element);
	}

	public attached() {
		const selectedValuesSubscription = this.bindingEngine.collectionObserver(this.selectedValues).subscribe(() => {
			this.selectedValues.forEach(id => {
				this.values[id] = id;
			});
		});

		this.subscriptions.push(selectedValuesSubscription);
	}

	public detached() {
		this.subscriptions.forEach(s => {
			s.dispose();
		});
	}

	public add(): void {
		this.selectedValues.push(undefined);
	}

	public delete(id: number) {
		const index = this.selectedValues.indexOf(id);

		if (index == -1) {
			return;
		}

		this.selectedValues.splice(index, 1);
		super.delete(id);
	}

	public onComboBoxValueChanged(id: number): void {
		if (id == undefined) {
			return;
		}

		const isExclusive = !!this.exclusiveAnswers[id];

		if (this.selectedExclusiveId || isExclusive) {
			Object.keys(this.values).forEach(k => {
				this.delete(this.values[k]);
			});

			this.selectedExclusiveId = isExclusive ? id : null;
			this.selectedValues.splice(0, this.selectedValues.length, id);
		}

		this.values[id] = id;

		this.dispatchValuesChangedEvent();
	}
}
